import { render } from "./AbsenceModal.vue?vue&type=template&id=8a256de6"
import script from "./AbsenceModal.vue?vue&type=script&lang=js"
export * from "./AbsenceModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/pslcal/meruhensya.com/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__